module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', _vm._l((_vm.data), function(label) {
    return _c('li', {
      staticClass: "label",
      class: {
        'invalid': !label.valid
      }
    }, [_c('span', {
      staticClass: "summary",
      style: ({
        color: label.summaryColor
      })
    }, [_c('span', {
      staticClass: "type",
      style: ({
        color: label.typeColor,
        backgroundColor: label.typeBgColor
      })
    }, [_vm._v(_vm._s(label.type))]), _vm._v(" "), (label.summary) ? _c('span', [_vm._v(_vm._s(label.summary))]) : _vm._e()]), _vm._v(" "), (label.count) ? _c('span', {
      staticClass: "count"
    }, [_vm._v("x" + _vm._s(label.count))]) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c63013ce"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/labels/index.vue
// module id = 291
// module chunks = 2 3 4 7 8 14 18 23